//import { AccountSettingService } from "@js/services/AccountSettingsService";
import { AuthService } from "@js/services/AuthService";
import { OrganisationService } from "@js/services/OrganisationService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";

import {
  AppPackagePricing,
  ApplicationUser,
  ApplicationUserClient,
  BillingFrequencyEnum,
  ContractLengthEnum,
  LicenseAppPackage,
  LicenseMasterStatusEnum,
  Organisation,
  OrganisationClient,
  PaymentClient,
  PricingFrequencyEnum,
  StaticDataClient,
  TeamSizeEnum,
  UserClient,
  UserRoleEnum,
  AuthClient,
  ApplicationUserCrudClient,
} from "@src/apis/ModularClient";
import { IndexService } from "@js/services/IndexService";
import { getOneUsingOData } from "@ccq/ts-lib";

export class AccountSettingsController {
  selectedTab: string;
  noMoreMails: boolean;

  //Brokers
  organisationAdminId: string;
  organisationAdmin: ApplicationUser;
  organisationAdminUsername: string;
  organisationUsers: ApplicationUser[];
  organisationUsersExceptAdmin: ApplicationUser[] = [];
  userOrganisation: Organisation;
  selectedBroker: ApplicationUser;
  currentPassword: string;
  newPassword: string;
  repeatPassword: string;

  newEmail: string;
  repeatEmail: string;

  passwordUpdated: boolean;
  emailUpdated: boolean;
  allActiveAppPackagePrices: AppPackagePricing[];
  allActiveAppPackagePricesForFrequency: AppPackagePricing[];
  selectedLicenseAppPackagePrice: LicenseAppPackage;
  selectedProduct: AppPackagePricing = null;

  assignedLicense: AppPackagePricing = null;

  isBroker: boolean;
  message: string;
  showMsgModal: boolean = false;
  showBrokerUsers: boolean = false;
  addBrokerUsers: boolean = false;
  addCustomPrice: boolean = false;
  changeInQuantity: boolean = false;
  isSelected: boolean = false;
  showAssignLicense: boolean = false;
  numberOfAssignedLicenses: number = 1;
  selectedPricingFrequency: boolean = false;
  selectedPricingFrequencyEnum: PricingFrequencyEnum = PricingFrequencyEnum.Monthly;
  showAlertmsg: boolean = false;
  showCancelModel: boolean = false;
  newBrokerUser: ApplicationUser;
  assignLicenseForm: ng.IFormController;
  assignCustompriceForm: ng.IFormController;
  remaningLicense: number = 0;
  dataLoading: boolean = false;
  isUpdateClicked: boolean = false;
  isSignUpClicked: boolean = false;
  selectedUserRole: UserRoleEnum = UserRoleEnum.None;
  isAdmin: boolean = false;
  selectedOrganisationId: number;
  selectedUserName: string = "";

  //Additional info
  additionalInfoText: string;
  CurrentTotalAmountToPay: number = 0;
  totalAmountToPay: number = 0;
  showIncreasingQuantityModal: boolean = false;
  showdescringQuantityModal: boolean = false;
  customePrice: string;
  numberOfLicense: number = 0;
  showCustomePricesuccessModal: boolean = false;
  newAmountInfoText: string;
  showNewAmount: boolean = false;
  isCustomPriceApplied: boolean = false;
  orderButtonText: string = "Update";
  orderButtonDisabled: boolean = false;
  showOrderButton: boolean = false;
  showCancelButton: boolean = false;
  billingCycle: PricingFrequencyEnum.Monthly;

  billingFrequencyOptions = [];
  teamSizeOptions = [];
  leadGenPackage: LicenseAppPackage;
  selectedleadGenPackage: LicenseAppPackage;
  isAddOnPaid: boolean = false;
  isContractChanged: boolean = false;
  alertMsg: string;
  isAddOnSelected: boolean = false;
  whitelabelPrice: number = 0;
  showWhiteLabelModal: boolean = false;
  newTotalPayment: number = 0;
  isSettingPage: boolean = true;
  endDate: Date;

  showLeadGenUrlModal: boolean = false;
  showLeadGenCancellationModal: boolean = false;
  leadGeneratorName: string;
  isLegacyLicense: boolean = false;
  licenseStatusText: string;
  reloadPage: boolean = false;
  whiteLabelledUrl: string = "";
  isMonthlySubscription: boolean = true;
  isPageReloadAfterCustomePrice: boolean = false;

  copyPaymentlink: boolean = false;
  companyEmailAddress: string;

  static $inject = [
    "$http",
    "$cookies",
    "AuthService",
    "AuthClient",
    "StaticDataClient",
    "RoleService",
    "UserClient",
    "$routeParams",
    "$location",
    "SelectListService",
    "OrganisationService",
    "OrganisationClient",
    "ApplicationUserClient",
    "PaymentClient",
    "IndexService",
    "ApplicationUserCrudClient",
  ];

  constructor(
    private $http: ng.IHttpService,
    private $cookies: ng.cookies.ICookiesService,
    private $auth: AuthService,
    private authClient: AuthClient,
    private staticDataClient: StaticDataClient,
    private $roleService: RoleService,
    private userClient: UserClient,
    private $routeParams: ng.route.IRouteParamsService,
    private $location: ng.ILocationService,
    private selectListService: SelectListService,
    private organisationService: OrganisationService,
    private organisationClient: OrganisationClient,
    private ApplicationUserClient: ApplicationUserClient,
    private PaymentClient: PaymentClient,
    private indexService: IndexService,
    private applicationUserCrudClient: ApplicationUserCrudClient,
  ) {
    this.billingFrequencyOptions = this.selectListService.GetBillingFrequencyOptions();
    this.teamSizeOptions = this.selectListService.GetTeamSizeOptions();
    this.getWhiteLabelledUrl();

    this.staticDataClient.getCompanyContactUsEmailAddress().then((response) => {
      this.companyEmailAddress = response;
    });

    this.$roleService.isAdminUser().then((response) => {
      this.isAdmin = response;
      this.initialiseAccountSettingsData();
    });

    this.selectedTab = this.$routeParams.selectedTab ? this.$routeParams.selectedTab : "license";
    this.leadGeneratorName = this.$cookies.get("leadgeneratorname");
  }

  private async initialiseAccountSettingsData() {
    if (this.$routeParams.userId && this.isAdmin) {
      const res = await getOneUsingOData(this.applicationUserCrudClient, {
        filter: { id: { eq: Number(this.$routeParams.userId) } },
        select: {
          userName: true,
          isOrganisationAdmin: true,
          organisationId: true,
          claimGroupsInApplicationUsers: true
        },
        expand: {
          claimGroupsInApplicationUsers: {
            claimGroup: true,
          },
        },
      });

      this.selectedUserName = res.userName;
      this.getSelectedPackagesForCurrentuser(this.$routeParams.userId);

      if (res.claimGroupsInApplicationUsers.find((role) => role.claimGroup.name === "OrganisationAdmin") !== undefined) {
        this.selectedOrganisationId = res.organisationId;
        this.organisationAdminUsername = res.userName;
        const organisation = await this.organisationClient.fetch(res.organisationId);
        this.userOrganisation = organisation;
        this.isAddOnSelected
          ? (this.isAddOnPaid = organisation.hasWhiteLabelAddOnPaid)
          : (this.isAddOnPaid = this.isAddOnSelected = organisation.hasWhiteLabelAddOnPaid);
        this.getLicenseStatusText();
        this.getBrokerUsers(this.selectedOrganisationId);

        this.selectedUserRole = UserRoleEnum.Broker;
      } else {
        this.selectedUserRole = UserRoleEnum.Client;
      }
    } else {
      this.selectedUserName = await this.indexService.currentUser.then((res) => {
        return res.userName;
      });
      this.getSelectedPackagesForCurrentuser(await this.indexService.currentUserId);
      this.getCurrentOrganisation();
    }
  }

  getCurrentOrganisation() {
    this.organisationService.getOrganisation().then((response) => {
      this.userOrganisation = response;
      this.isAddOnSelected
        ? (this.isAddOnPaid = response.hasWhiteLabelAddOnPaid)
        : (this.isAddOnPaid = this.isAddOnSelected = response.hasWhiteLabelAddOnPaid);
      this.selectedOrganisationId = this.userOrganisation.id;
      this.getBrokerUsers(this.selectedOrganisationId);
    });
  }

  getBrokerUsers(orgId): void {
    this.organisationClient.getAllOrganisationMembers(orgId).then((response) => {
      this.organisationUsers = response;
      this.numberOfAssignedLicenses = this.organisationUsers.filter((e) => e.subscriptionStatus > 0).length;
      if (
        this.selectedLicenseAppPackagePrice &&
        this.selectedLicenseAppPackagePrice.status != LicenseMasterStatusEnum.PreSubscription &&
        this.selectedLicenseAppPackagePrice.status != LicenseMasterStatusEnum.None
      )
        this.remaningLicense = this.selectedLicenseAppPackagePrice.totalQuantity - this.numberOfAssignedLicenses;
    });
    this.userClient.getOrganisationNonAdminUsers(orgId).then((response) => {
      this.organisationUsersExceptAdmin = response;
    });
  }

  applyEmailChange() {
    if (this.newEmail && this.repeatEmail && this.newEmail === this.repeatEmail) {
      this.$auth.changeEmail(this.newEmail).then((response) => {
        delete this.newEmail;
        delete this.repeatEmail;
        this.emailUpdated = true;
        this.$roleService.goHomeBasedOnUser();
      });
    }
  }
  async applyPasswordChange() {
    if (this.newPassword && this.repeatPassword && this.newPassword === this.repeatPassword) {
      await this.authClient.changePassword({ oldPassword: this.currentPassword, newPassword: this.newPassword });

      delete this.currentPassword;
      delete this.newPassword;
      delete this.repeatPassword;
      this.passwordUpdated = true;
      this.$roleService.goHomeBasedOnUser();
    }
  }

  getAssignedPackage(userId: number) {
    this.PaymentClient.getAllActivePackagePrices(userId).then((response) => {
      this.allActiveAppPackagePrices = response;
      if (
        this.selectedLicenseAppPackagePrice &&
        this.selectedLicenseAppPackagePrice.status != LicenseMasterStatusEnum.PreSubscription &&
        this.selectedLicenseAppPackagePrice.status != LicenseMasterStatusEnum.None
      ) {
        var selectedProduct = this.allActiveAppPackagePrices.filter(
          (o1) =>
            o1.appPackageId === this.selectedLicenseAppPackagePrice.appPackageId &&
            o1.pricingFrequency === this.returnPricingFrequency(this.selectedLicenseAppPackagePrice.billingFrequency) &&
            o1.contractLength == this.selectedLicenseAppPackagePrice.contractLength,
        );
        if (selectedProduct.length > 0) {
          this.selectedProduct = selectedProduct.map((e) => ((e.quantity = this.quantity(e.appPackageId)), e))[0];

          this.isMonthlySubscription =
            this.selectedProduct.pricingFrequency == PricingFrequencyEnum.Monthly ? true : false;

          if (this.hasLegacyLicense()) {
            this.selectedProduct.priceAmount =
              this.selectedProduct.pricingFrequency == PricingFrequencyEnum.Monthly ? 35 : 350;
            this.isLegacyLicense = true;
          }

          this.getAddOnPrice(this.selectedProduct.pricingFrequency);
          this.getEndDate(this.selectedLicenseAppPackagePrice.activeFromDate);

          if (
            this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PaidUp ||
            this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PaymentProcessing ||
            this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PreCancel
          ) {
            this.assignedLicense = JSON.parse(JSON.stringify(this.selectedProduct));
          }
        }
      } else {
        this.selectedProduct = this.allActiveAppPackagePrices[0];
      }
    });
  }

  getSelectedPackagesForCurrentuser(userId: number) {
    this.PaymentClient.getSelectedPackageForCurrentuser(userId).then((response) => {
      if (response != null) {
        this.selectedLicenseAppPackagePrice = response.find((p) => !p.appPackage.isLeadGenerator);
        this.selectedleadGenPackage = response.find((p) => p.appPackage.isLeadGenerator);
      }
      //Code Review
      if (
        this.selectedLicenseAppPackagePrice != null &&
        this.selectedLicenseAppPackagePrice.pricePerLicense != 0 &&
        this.selectedLicenseAppPackagePrice.status != LicenseMasterStatusEnum.None
      ) {
        if (
          this.selectedLicenseAppPackagePrice.totalPricePerCycle >
          this.selectedLicenseAppPackagePrice.pricePerLicense * this.selectedLicenseAppPackagePrice.totalQuantity
        ) {
          this.isAddOnSelected = true;
        }
      }

      this.getAssignedPackage(userId);
      var pricingFrequency = this.selectedLicenseAppPackagePrice
        ? this.selectedLicenseAppPackagePrice.billingFrequency
        : PricingFrequencyEnum.Monthly;

      if (this.selectedLicenseAppPackagePrice != null) {
        this.selectedPricingFrequency =
          this.selectedLicenseAppPackagePrice &&
          this.selectedLicenseAppPackagePrice?.billingFrequency == BillingFrequencyEnum.Monthly
            ? false
            : true;
        if (this.selectedLicenseAppPackagePrice.isCustomPriceApplied) {
          this.isCustomPriceApplied = true;
        }
      }

      this.getActivePackagePricesForFrequency(pricingFrequency);
    });
  }

  getActivePackagePricesForFrequency(pricingFrequency) {
    this.PaymentClient.getActivePackagePricesForFrequency(pricingFrequency, this.selectedUserRole).then((response) => {
      if (
        this.selectedLicenseAppPackagePrice &&
        this.selectedLicenseAppPackagePrice.status != LicenseMasterStatusEnum.None &&
        this.selectedLicenseAppPackagePrice.status != LicenseMasterStatusEnum.PreSubscription &&
        this.selectedLicenseAppPackagePrice.status != LicenseMasterStatusEnum.Cancelled
      ) {
        this.allActiveAppPackagePricesForFrequency = response.filter(
          (al) =>
            this.returnContractLength(al.contractLength) >=
            this.returnContractLength(this.selectedLicenseAppPackagePrice.contractLength),
        );
        this.getAddOnPrice(pricingFrequency);
      } else {
        this.allActiveAppPackagePricesForFrequency = response;
        this.getAddOnPrice(
          this.selectedPricingFrequency == false ? PricingFrequencyEnum.Monthly : PricingFrequencyEnum.Yearly,
        );
      }
    });
  }

  callGetActivePackagePricesForFrequency() {
    var pricingFrequency: PricingFrequencyEnum =
      this.selectedPricingFrequency == false ? PricingFrequencyEnum.Monthly : PricingFrequencyEnum.Yearly;
    this.getActivePackagePricesForFrequency(pricingFrequency);
  }

  quantity(packageId) {
    var found = this.selectedLicenseAppPackagePrice.appPackageId == packageId;

    if (found) {
      return this.selectedLicenseAppPackagePrice.totalQuantity;
    } else {
      return 1;
    }
  }

  convertEnumToString(value) {
    switch (value) {
      case PricingFrequencyEnum.Monthly:
        return "month";
      case PricingFrequencyEnum.Yearly:
        return "year";
      default:
        return "";
    }
  }

  returnSubscriptionStatus(value) {
    switch (value) {
      case LicenseMasterStatusEnum.PaidUp:
      case LicenseMasterStatusEnum.PreCancel:
        return "Paid Up";
      case LicenseMasterStatusEnum.PayFailure:
        return "Pay Failure";
      case LicenseMasterStatusEnum.Cancelled:
        return "Cancelled";
      case LicenseMasterStatusEnum.Unpaid:
        return "Unpaid";
      case LicenseMasterStatusEnum.PaymentProcessing:
        return "Payment Processing";
      case LicenseMasterStatusEnum.Trial:
        return "Trial";
      default:
        return "Unsubscribed";
    }
  }

  /*isUpdateRequired() {
            if (this.isBroker) {
                if (this.selectedProduct && this.oldProduct) {
                    if (this.selectedProduct != this.oldProduct) {
                        return this.changeInProduct(true);
                    } else {
                        if (this.selectedProduct[0].AppPackageId != this.oldProduct[0].AppPackageId) {
                            return true;
                        } else {
                            if (this.selectedProduct[0].Quantity != this.oldProduct[0].Quantity) {
                                return this.changeInProduct(true);
                            } else {
                                return this.changeInProduct(false);
                            }
                        }

                    }
                } else if (this.selectedProduct != this.oldProduct) {
                    return this.changeInProduct(true);
                }
            }
        }*/

  managePayment() {
    this.PaymentClient.createPortalSession().then((response) => {
      window.open(response, "_blank");
    });
  }

  onClickOfCancel() {
    if (
      this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PaymentProcessing &&
      !this.isDirectDebitActive(this.selectedLicenseAppPackagePrice.activeFromDate)
    ) {
      return;
    }

    this.PaymentClient.isSubscriptionCancelable(this.selectedLicenseAppPackagePrice.externalSubscriptionRef).then(
      (response) => {
        if (response) {
          this.showCancelModel = true;
        } else {
          this.showAlertmsg = true;
          this.alertMsg =
            "Sorry, you can not cancel your subscription at this time since you have committed to a " +
            this.getContractLengthText(this.assignedLicense.pricingFrequency, this.assignedLicense.contractLength);
        }
      },
    );
  }

  cancelSubscription(subscriptionId, isLeadGeneratorLicense = false) {
    this.dataLoading = true;
    this.showCancelModel = false;
    this.showLeadGenCancellationModal = false;
    this.PaymentClient.cancelSubscription(subscriptionId)
      .then((response) => {
        this.message = `Your subscription has been successfully cancelled however, you can continue to enjoy using the application until ${response}`;
        if (isLeadGeneratorLicense) {
          this.selectedleadGenPackage.status = LicenseMasterStatusEnum.PreCancel;
        } else {
          this.selectedLicenseAppPackagePrice.status = LicenseMasterStatusEnum.PreCancel;
        }
      })
      .catch(() => {
        this.message = "There is problem cancelling the subscription, Please try later.";
      })
      .finally(() => {
        this.showMsgModal = true;
        this.dataLoading = false;
      });
  }

  unCancelSubscription(subscriptionId, isLeadGeneratorLicense = false) {
    this.dataLoading = true;
    this.PaymentClient.unCancelSubscription(subscriptionId)
      .then((response) => {
        this.message = `You have successfully renewed your subscription.`;
        if (isLeadGeneratorLicense) {
          this.selectedleadGenPackage.status = LicenseMasterStatusEnum.PaidUp;
        } else {
          this.selectedLicenseAppPackagePrice.status = LicenseMasterStatusEnum.PaidUp;
        }
      })
      .catch(() => {
        this.message = "There is problem renewing your subscription, Please try later.";
      })
      .finally(() => {
        this.showMsgModal = true;
        this.dataLoading = false;
      });
  }

  /*getLicense(selectedUserName) {
            this.paymentClient.getLicense(selectedUserName).then((response) => {
                this.licenseData = response;
            });
        }*/

  isPackageSelected(selectedProduct) {
    if (selectedProduct && this.selectedProduct) {
      var found = this.selectedProduct.id == selectedProduct.Id;

      if (found) {
        return true;
      } else {
        return false;
      }
    }
  }

  isAssignedproduct(product) {
    if (product && this.assignedLicense) {
      var found = this.assignedLicense.id == product.Id;

      if (found) {
        return true;
      } else {
        return false;
      }
    }
  }

  confirmUpdateSubscription() {
    this.message = ``;
    if (this.isAddOnPaid && !this.isAddOnSelected) {
      if (this.assignedLicense.quantity == this.selectedProduct.quantity) {
        this.onClickOfAddOnRemove();
        return;
      } else {
        this.message += `You are removing whitelabelling from your subscription. `;
      }
    } else if (!this.isAddOnPaid && this.isAddOnSelected) {
      this.message += `You are adding whitelabelling to your subscription. `;
    }
    if (this.assignedLicense.quantity < this.selectedProduct.quantity) {
      this.message += `You are increasing the number of licenses from ${this.assignedLicense.quantity} to ${
        this.selectedProduct.quantity
      } and your ${
        this.selectedProduct.pricingFrequency == PricingFrequencyEnum.Monthly ? "Monthly" : "Yearly"
      } payment will increase from £${this.assignedLicense.quantity * this.assignedLicense.priceAmount} to £${
        this.selectedProduct.quantity * this.selectedProduct.priceAmount
      }. Click Proceed to apply this change.`;
      this.showIncreasingQuantityModal = true;
    } else if (this.assignedLicense.quantity > this.selectedProduct.quantity) {
      this.message += `You are decreasing the number of licenses from ${this.assignedLicense.quantity} to ${this.selectedProduct.quantity}. Are you sure you wish to continue?`;
      this.showdescringQuantityModal = true;
    } else {
      this.showIncreasingQuantityModal = true;
    }
  }

  async updateSubscription() {
    this.dataLoading = true;
    this.isUpdateClicked = true;

    const updateSubscriptionPromise = (
      this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PreCancel
        ? this.PaymentClient.updatePreCancelSubscription(this.selectedUserName, this.isAddOnSelected, true, [
            this.selectedProduct,
          ])
        : this.PaymentClient.updatePlanPrice(this.selectedUserName, this.isAddOnSelected, false, [this.selectedProduct])
    ) as Promise<LicenseAppPackage>;

    try {
      await updateSubscriptionPromise;
      this.assignedLicense = JSON.parse(JSON.stringify(this.selectedProduct));
      if (this.isLegacyLicense) {
        if (this.assignedLicense.contractLength != ContractLengthEnum.None) {
          this.isLegacyLicense = false;
        }
      }
      this.numberOfLicense = this.assignedLicense.quantity;
      this.remaningLicense = this.assignedLicense.quantity - this.numberOfAssignedLicenses;
      // this.getLicense(this.selectedUserName);
      this.message = "Your subscription has been updated successfully.";
      this.isUpdateClicked = false;
      this.getEndDate(this.selectedLicenseAppPackagePrice.activeFromDate);
      this.selectedLicenseAppPackagePrice.contractLength = this.selectedProduct.contractLength;
    } catch (e) {
      this.message = "There is problem updating the subscription, Please try later.";
      this.isUpdateClicked = false;
      if (this.selectedUserName.length > 0) {
        this.getSelectedPackagesForCurrentuser(this.$routeParams.userId);
      } else {
        this.getSelectedPackagesForCurrentuser(await this.indexService.currentUserId);
      }
    } finally {
      this.callGetActivePackagePricesForFrequency();
      this.showMsgModal = true;
      this.dataLoading = false;
      this.showIncreasingQuantityModal = false;
      this.showdescringQuantityModal = false;
      this.showWhiteLabelModal = false;
      this.showNewAmount = false;
      this.isContractChanged = false;
      this.changeInProduct(false);
      this.isAddOnSelected
        ? (this.isAddOnPaid = this.isAddOnSelected = true)
        : (this.isAddOnPaid = this.isAddOnSelected = false);
    }
  }

  closeModal() {
    this.showMsgModal = false;
    this.message = null;
    if (this.reloadPage || this.selectedLicenseAppPackagePrice == null || this.isPageReloadAfterCustomePrice) {
      if (
        this.$routeParams.selectedTab ||
        this.selectedLicenseAppPackagePrice == null ||
        this.isPageReloadAfterCustomePrice
      ) {
        window.location.reload();
      } else {
        this.$location.path("/settings/" + this.$routeParams.userId + "/leadgenerator");
      }
    }
  }

  createCheckoutSession() {
    this.isSignUpClicked = true;
    this.PaymentClient.createCheckoutSession(this.isAddOnSelected, this.selectedUserName, this.selectedProduct, null)
      .then((response) => {
        window.location.assign(response.sessionUrl);
      })
      .catch(() => {
        this.message = "There is problem signing up, Please try later.";
        this.isSignUpClicked = false;
        this.showMsgModal = true;
      })
      .finally(() => {
        this.isSignUpClicked = false;
      });
  }

  assignLicense(broker) {
    this.dataLoading = true;
    this.selectedBroker = broker;
    this.PaymentClient.assignLicense(this.selectedBroker.id, this.selectedBroker.organisationId)
      .then((response) => {
        if (response) {
          this.selectedBroker.subscriptionStatus = 1;
          this.numberOfAssignedLicenses += 1;
          this.remaningLicense = this.assignedLicense.quantity - this.numberOfAssignedLicenses;
          this.message = `Subscription is successfully assigned to ${this.selectedBroker.fullName}.`;
          this.showMsgModal = true;
        } else {
          this.message = "There is problem assigning the subscription, Please try later.";
          this.showMsgModal = true;
        }
      })
      .finally(() => {
        this.dataLoading = false;
        this.showAlertmsg = false;
      });
  }

  unAssignLicense(broker) {
    this.dataLoading = true;
    this.PaymentClient.unAssignLicense(broker.id)
      .then((response) => {
        if (response) {
          broker.subscriptionStatus = null;
          this.numberOfAssignedLicenses -= 1;
          this.remaningLicense = this.assignedLicense.quantity - this.numberOfAssignedLicenses;
          this.message = `Subscription is successfully unassigned to ${broker.fullName}.`;
          this.showMsgModal = true;
        } else {
          this.message = "There is problem unassigning the subscription, Please try later.";
          this.showMsgModal = true;
        }
      })
      .finally(() => {
        this.dataLoading = false;
        this.showAlertmsg = false;
      });
  }

  onUpdatingLiceseQuantity() {
    if (
      this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PaymentProcessing &&
      !this.isDirectDebitActive(this.selectedLicenseAppPackagePrice.activeFromDate)
    ) {
      this.selectedProduct.quantity = this.selectedLicenseAppPackagePrice.totalQuantity;
      return;
    }

    if (
      this.selectedProduct.quantity > this.assignedLicense?.quantity ||
      this.selectedProduct.quantity < this.assignedLicense?.quantity ||
      this.selectedProduct.id != this.assignedLicense?.id
    ) {
      if (this.numberOfAssignedLicenses > this.selectedProduct.quantity) {
        this.showAlertmsg = true;
        this.alertMsg = `You are attempting to downgrade your total number of licences when they are already in use. In order to downgrade, please first unassign licenses via the "Company broker users" menu. You can then reduce your total number of licenses and update your subscription.`;
        this.selectedProduct.quantity = this.numberOfAssignedLicenses;
      } else {
        this.showNewAmount = true;
        this.changeInProduct(true);
        this.changeInQuantity = true;
        this.showAlertmsg = false;
        this.alertMsg = null;
        this.setTotalAmount();
      }
    } else if (this.selectedProduct.quantity == this.assignedLicense?.quantity) {
      this.setTotalAmount();
      this.showOrderButton = false;
      this.changeInQuantity = false;
      this.changeInProduct(false);
      this.showAlertmsg = false;
      this.alertMsg = null;
    }
  }

  assignLicenses() {
    const assignedLicenseusers = [];
    this.newBrokerUser.referrerOther = "";
    this.newBrokerUser.applicantDefinedRoleOther = "";
    this.newBrokerUser.profilePictureUrl = "";
    this.newBrokerUser.roleDescription = "";
    this.newBrokerUser.miniBio = "";
    this.newBrokerUser.representative = "";
    this.newBrokerUser.securityStamp = "";
    this.newBrokerUser.fullName = "";
    this.newBrokerUser.lenderProductTypesText = "";
    this.newBrokerUser.introducerCode = "";
    this.newBrokerUser.dealClientUniqueRef = "";
    this.newBrokerUser.inviteCode = "";
    this.newBrokerUser.orgCode = "";
    this.newBrokerUser.oidcId = this.newBrokerUser.email;
    this.newBrokerUser.name = this.newBrokerUser.email;
    this.newBrokerUser.userName = this.newBrokerUser.email;
    this.newBrokerUser.phoneNumber = "";
    assignedLicenseusers.push(this.newBrokerUser);
    this.dataLoading = true;

    this.userClient
      .registerBrokerUsers(this.selectedUserName, assignedLicenseusers)
      .then((response: string) => {
        if (response.length == 0) {
          this.message = `Successfully added and assigned a license to ${assignedLicenseusers[0].firstName} ${assignedLicenseusers[0].lastName}`;
          this.showMsgModal = true;
          this.newBrokerUser = {
            id: null,
          } as ApplicationUser;
          this.assignLicenseForm.$setPristine();
          this.assignLicenseForm.$setUntouched();
          this.getBrokerUsers(this.selectedOrganisationId);
        } else {
          this.message = response;
          this.showMsgModal = true;
          this.newBrokerUser = {
            id: null,
          } as ApplicationUser;
          this.assignLicenseForm.$setPristine();
          this.assignLicenseForm.$setUntouched();
        }
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  cancelChanges() {
    this.changeInProduct(false);
    this.selectedProduct = JSON.parse(JSON.stringify(this.assignedLicense));
    if (this.hasLegacyLicense()) {
      this.selectedProduct.priceAmount =
        this.selectedProduct.pricingFrequency == PricingFrequencyEnum.Monthly ? 35 : 350;
      this.isLegacyLicense = true;
      this.whitelabelPrice = 0;
    }
    this.isAddOnSelected = this.isAddOnPaid;
    this.showAlertmsg = false;
    this.showdescringQuantityModal = false;
    this.showIncreasingQuantityModal = false;
    this.showWhiteLabelModal = false;
    this.showNewAmount = false;
    this.isContractChanged = false;
  }

  setTotalAmount() {
    this.newTotalPayment = this.selectedProduct.priceAmount * this.selectedProduct.quantity;
  }

  goToCompanySettings() {
    this.$location.path("/Organisations");
  }

  assignCustomPrice() {
    this.dataLoading = true;
    this.isCustomPriceApplied = true;

    if (
      this.selectedLicenseAppPackagePrice != null &&
      this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PayFailure
    ) {
      this.message = `Custom price can't be applied for license with status 'Incomplete'.`;
      this.dataLoading = false;
      this.showMsgModal = true;
      return;
    }

    const customPricePromise =
      this.selectedLicenseAppPackagePrice != null &&
      (this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PaidUp ||
        this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PaymentProcessing ||
        this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PreCancel ||
        this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.Unpaid)
        ? this.PaymentClient.assignCustomPrice(
            this.customePrice,
            this.selectedProduct.quantity,
            this.selectedOrganisationId,
            this.isAddOnSelected,
            this.isMonthlySubscription,
          )
        : this.PaymentClient.offerCustomPrice(
            this.customePrice,
            this.selectedProduct.quantity,
            this.selectedOrganisationId,
            this.isAddOnSelected,
            this.isMonthlySubscription,
          );

    customPricePromise
      .then((response) => {
        if (response) {
          this.message = `Custom price has been applied successfully.`;
          this.showMsgModal = true;
          this.selectedLicenseAppPackagePrice.totalPricePerCycle = Number(this.customePrice);
        } else {
          this.message = "There is problem assigning the custom price, Please try later.";
          this.showMsgModal = true;
          this.isCustomPriceApplied = false;
        }
      })
      .finally(() => {
        this.dataLoading = false;
        this.customePrice = null;
        this.assignCustompriceForm.$setPristine();
        this.assignCustompriceForm.$setUntouched();
        this.isPageReloadAfterCustomePrice = true;
      });
  }

  assignStandardPrice() {
    this.dataLoading = true;
    this.PaymentClient.assignStandardPrice(this.selectedOrganisationId)
      .then((response) => {
        if (response) {
          this.message = `Standard price has been applied successfully.`;
          this.showMsgModal = true;
          this.isCustomPriceApplied = false;
        } else {
          this.message = "There is problem assigning the standard price, Please try later.";
          this.showMsgModal = true;
        }
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  changeInProduct(value) {
    if (
      this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PaidUp ||
      this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PreCancel ||
      this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PaymentProcessing
    ) {
      this.showOrderButton = value;
      this.showCancelButton = value;
    }
  }

  orderButton() {
    if (this.isContractChanged) {
      this.confirmContractLengthChange();
    } else {
      this.confirmUpdateSubscription();
    }
  }

  cancelButton() {
    this.cancelChanges();
  }

  offerLeadGeneratorLicense() {
    this.dataLoading = true;
    if (this.userOrganisation != null) {
      this.leadGenPackage.licenseMasterId = this.userOrganisation.licenseMasterId;
    }

    if (!this.leadGenPackage.id) {
      this.leadGenPackage.licenseMaster = null;
      this.leadGenPackage.appPackage = null;
      this.leadGenPackage.externalItemRef = "";
      this.leadGenPackage.externalSubscriptionRef = "";
      this.leadGenPackage.authCode = "";
      this.leadGenPackage.invoiceUrl = "";
      this.leadGenPackage.appPackageId = 0;
    }

    this.PaymentClient.offerLeadGeneratorLicense(this.leadGenPackage)
      .then((response) => {
        if (response) {
          this.message =
            this.leadGeneratorName + ` license offer email has been sent to ${this.userOrganisation.name} admin.`;
          this.showMsgModal = true;
          this.reloadPage = true;
        } else {
          this.message =
            "There is problem assigning the offer for " + this.leadGeneratorName + ". Please contact Brickflow.";
          this.showMsgModal = true;
        }
      })
      .then(() => {
        return this.organisationClient.saveOrganisation(this.userOrganisation);
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  onSelectingAddon(selected: boolean) {
    if (
      this.selectedLicenseAppPackagePrice != null &&
      this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PaymentProcessing &&
      !this.isDirectDebitActive(this.selectedLicenseAppPackagePrice.activeFromDate)
    ) {
      return;
    }

    this.isAddOnSelected = selected;
    this.changeInProduct(
      this.isAddOnPaid != this.isAddOnSelected || this.assignedLicense.quantity != this.selectedProduct.quantity,
    );
  }

  onClickOfAddOnRemove() {
    if (
      this.selectedLicenseAppPackagePrice != null &&
      this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PaymentProcessing &&
      !this.isDirectDebitActive(this.selectedLicenseAppPackagePrice.activeFromDate)
    ) {
      return;
    }
    this.showWhiteLabelModal = true;
  }

  /* addAddOnToLicense() {
            if ((this.selectedLicenseAppPackagePrice == null) || (this.selectedLicenseAppPackagePrice != null && (this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PreSubscription || this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.None || this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.Cancelled))) {
                this.isAddOnSelected = true;
            } else if (this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PayFailure) {
                this.alertMsg = "Please pay your pending payment to update subscription."
                this.showAlertmsg = true;
                this.changeInQuantity = false;
                this.isContractChanged = true;
            }
            else {
                this.dataLoading = true;
                this.PaymentClient.addAddOnToLicense(this.userOrganisation.id).then((response) => {
                    if (response) {
                        this.isAddOnPaid = this.isAddOnSelected = true;
                    } else {
                        this.message += "\nThere is problem adding Add-on, Please try later."
                    }
                }).finally(() => {
                    this.dataLoading = false;
                });
            }
        }

        removeAddOnFromLicense() {
            if ((this.selectedLicenseAppPackagePrice == null) || (this.selectedLicenseAppPackagePrice != null && (this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PreSubscription || this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.None || this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.Cancelled ))) {
                this.isAddOnSelected = false;
                this.showWhiteLabelModal = false;
            } else if (this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PayFailure) {
                this.alertMsg = "Please pay your pending payment to update subscription."
                this.showAlertmsg = true;
                this.changeInQuantity = false;
                this.isContractChanged = true;
            }
            else {
                this.dataLoading = true;
                this.PaymentClient.removeAddOnFromLicense(this.userOrganisation.id).then((response) => {
                    if (response) {
                        this.isAddOnPaid = this.isAddOnSelected = false;
                    } else {
                        this.message += "\nThere is problem removing a Add-on, Please try later."
                        this.showMsgModal = true;
                    }
                }).finally(() => {
                    this.dataLoading = false;
                    this.showWhiteLabelModal = false;
                });
            }
        }*/

  onSelectingPackage(product: AppPackagePricing) {
    if (
      this.selectedLicenseAppPackagePrice != null &&
      this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PaymentProcessing &&
      !this.isDirectDebitActive(this.selectedLicenseAppPackagePrice.activeFromDate)
    ) {
      return;
    }

    if (
      this.selectedLicenseAppPackagePrice == null ||
      this.selectedLicenseAppPackagePrice.status != LicenseMasterStatusEnum.PayFailure
    ) {
      this.selectedProduct = product;
      if (this.assignedLicense) this.selectedProduct.quantity = this.assignedLicense.quantity;
      if (!this.assignedLicense || this.selectedProduct.id != this.assignedLicense.id) {
        if (this.selectedProduct.id != this.assignedLicense.id && this.isLegacyLicense) {
          this.getAddOnPrice(this.selectedProduct.pricingFrequency);
        }
        this.isContractChanged = true;
        this.changeInProduct(true);
        this.showAlertmsg = false;
        this.alertMsg = null;
      } else {
        this.isContractChanged = false;
        if (this.hasLegacyLicense()) {
          this.selectedProduct.priceAmount =
            this.selectedProduct.pricingFrequency == PricingFrequencyEnum.Monthly ? 35 : 350;
          this.whitelabelPrice = 0;
          this.isLegacyLicense = true;
          this.isAddOnSelected = true;
        }
        this.changeInProduct(false);
        this.showAlertmsg = false;
        this.alertMsg = null;
      }
    } else {
      this.alertMsg = "Please pay your pending payment to change the contract.";
      this.showAlertmsg = true;
      this.changeInQuantity = false;
      this.isContractChanged = true;
    }
  }

  confirmContractLengthChange() {
    this.message = `Are you sure you wish to continue?`;
    this.showMsgModal = true;
  }

  returnContractLength(value) {
    switch (value) {
      case ContractLengthEnum.TwoYearly:
        return 2;
      case ContractLengthEnum.Yearly:
        return 1;
      default:
        return 0;
    }
  }

  getAddOnPrice(frequency: PricingFrequencyEnum) {
    if (this.hasLegacyLicense()) {
      this.whitelabelPrice = 0;
    } else {
      this.PaymentClient.getWhiteLabelPrice(frequency).then((response) => {
        this.whitelabelPrice = Number(response);
      });
    }
  }

  convertEnumToStringForLeadGenerator(value) {
    switch (value) {
      case PricingFrequencyEnum.Monthly:
        return "Monthly";
      case PricingFrequencyEnum.Monthly:
        return "Monthly";
      default:
        return "";
    }
  }

  calculateTotal(product: AppPackagePricing, isUpdated: boolean = false): number {
    var total = Number(product ? product?.quantity * product?.priceAmount : 0);

    if (!isUpdated) {
      if (!this.isLegacyLicense) {
        total += Number(this.isAddOnPaid ? this.whitelabelPrice : 0);
      }
    }

    if (isUpdated) {
      total += Number(this.isAddOnSelected ? this.whitelabelPrice : 0);
    }

    return total;
  }

  showLeadeGeneratorForm() {
    if (this.selectedleadGenPackage && this.selectedleadGenPackage.status == LicenseMasterStatusEnum.Offered) {
      return true;
    } else {
      return false;
    }
  }

  showLeadeGeneratorPackage() {
    if (this.selectedleadGenPackage && this.selectedleadGenPackage.status != LicenseMasterStatusEnum.Offered) {
      return true;
    } else {
      return false;
    }
  }

  acceptLeadGenLicense() {
    this.dataLoading = true;
    this.PaymentClient.createCheckoutSessionForLeadGen(this.selectedleadGenPackage)
      .then((response) => {
        window.location.assign(response.sessionUrl);
      })
      .catch(() => {
        this.message = "There is problem signing up, Please try later.";
        this.showMsgModal = true;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  createCheckoutForCustomPrice() {
    this.dataLoading = true;
    this.isSignUpClicked = true;
    this.PaymentClient.createCheckoutSessionForCustomPrice(
      this.isAddOnSelected,
      this.selectedUserName,
      this.selectedLicenseAppPackagePrice,
      null,
    )
      .then((response) => {
        if (this.copyPaymentlink) {
          navigator.clipboard.writeText(response.sessionUrl);
          this.message = "Code has been copied to the clipboard";
          this.showMsgModal = true;
          this.copyPaymentlink = false;
        } else {
          window.location.assign(response.sessionUrl);
        }
      })
      .catch(() => {
        this.message = "There is problem signing up, Please try later.";
        this.isSignUpClicked = false;
        this.showMsgModal = true;
      })
      .finally(() => {
        this.dataLoading = false;
        this.isSignUpClicked = false;
      });
  }

  cancelLeadGeneratorOffer() {
    this.PaymentClient.cancelLeadGeneratorOffer(this.selectedleadGenPackage.id)
      .then((response) => {
        if (response) {
          this.message = this.leadGeneratorName + ` offer has been cancelled.`;
          this.showMsgModal = true;
          this.leadGenPackage = null;
          this.reloadPage = true;
        } else {
          this.message = "There is problem canceling the offer, Please try later.";
          this.showMsgModal = true;
        }
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  showAssignLicenseSection() {
    if (
      (this.remaningLicense >= 1 &&
        this.selectedLicenseAppPackagePrice &&
        (this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PaidUp ||
          this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PreCancel ||
          this.selectedLicenseAppPackagePrice.status == LicenseMasterStatusEnum.PaymentProcessing)) ||
      this.userOrganisation?.isOnFreeTrial
    ) {
      return true;
    } else {
      return false;
    }
  }

  getContractLengthText(frequency: PricingFrequencyEnum, contractLength: number) {
    if (contractLength == 1) {
      return "1 Year Plan";
    } else if (contractLength == 2) {
      return "2 Year Plan";
    } else {
      return frequency == PricingFrequencyEnum.Monthly ? "Monthly Plan" : "Annual Plan";
    }
  }

  returnNumberOfLicenseText(product) {
    return this.selectedProduct.quantity > 1
      ? `${this.selectedProduct.quantity} licenses`
      : `${this.selectedProduct.quantity} license`;
  }

  isDirectDebitActive(activeFromDate) {
    var currentDate = new Date();
    var newDate = new Date(activeFromDate.getFullYear(), activeFromDate.getMonth(), activeFromDate.getDate() + 7);

    return currentDate > newDate;
  }

  getTeamSizeDescription(teamSizeEnum: TeamSizeEnum) {
    var teamSizeOptions = this.selectListService.GetTeamSizeOptions();

    var teamSizeInfo = teamSizeOptions.find((option) => option.key == teamSizeEnum);
    if (teamSizeInfo) {
      return teamSizeInfo.displayName;
    }

    return "";
  }

  generateButtonCode() {
    if (this.organisationService.hasValidWhitelabelProperties(this.userOrganisation)) {
      this.message = `${this.whiteLabelledUrl}${this.userOrganisation.organisationCode}#!/e/devfinancecriteria/`;
      this.showLeadGenUrlModal = true;
    } else {
      this.message =
        "To access your " +
        this.leadGeneratorName +
        " URL please ensure you have an active White Label add-on and you have completed the URL Company Code in your company settings (under White Label)";
      this.showMsgModal = true;
    }
  }

  generateButtonAllLoanCode() {
    if (this.organisationService.hasValidWhitelabelProperties(this.userOrganisation)) {
      this.message = `${this.whiteLabelledUrl}${this.userOrganisation.organisationCode}#!/allloans`;
      this.showLeadGenUrlModal = true;
    } else {
      this.showMsgModal = true;
      this.message =
        "To access your " +
        this.leadGeneratorName +
        " URL please ensure you have an active White Label add-on and you have completed the URL Company Code in your company settings (under White Label)";
    }
  }

  generateButtonBridgingLoanCode() {
    if (this.organisationService.hasValidWhitelabelProperties(this.userOrganisation)) {
      this.message = `${this.whiteLabelledUrl}${this.userOrganisation.organisationCode}#!/e/bridgingcriteria`;
      this.showLeadGenUrlModal = true;
    } else {
      this.showMsgModal = true;
      this.message =
        "To access your " +
        this.leadGeneratorName +
        " URL please ensure you have an active White Label add-on and you have completed the URL Company Code in your company settings (under White Label)";
    }
  }

  generateButtonCommercialLoanCode() {
    if (this.organisationService.hasValidWhitelabelProperties(this.userOrganisation)) {
      this.message = `${this.whiteLabelledUrl}${this.userOrganisation.organisationCode}#!/e/commercialcriteria`;
      this.showLeadGenUrlModal = true;
    } else {
      this.showMsgModal = true;
      this.message =
        "To access your " +
        this.leadGeneratorName +
        " URL please ensure you have an active White Label add-on and you have completed the URL Company Code in your company settings (under White Label)";
    }
  }

  copyButtonCodeToClipBoard() {
    this.showLeadGenUrlModal = false;
    navigator.clipboard.writeText(this.message);
    this.message = "Code has been copied to the clipboard";
    this.showMsgModal = true;
  }

  getEndDate(startDate: Date) {
    const startDateCopy: Date = new Date(startDate.getTime());

    switch (this.selectedProduct.contractLength) {
      case ContractLengthEnum.Yearly:
        startDateCopy.setFullYear(startDateCopy.getFullYear() + 1);
        this.endDate = startDateCopy;
        break;
      case ContractLengthEnum.TwoYearly:
        startDateCopy.setFullYear(startDateCopy.getFullYear() + 2);
        this.endDate = startDateCopy;
        break;
      default:
        this.endDate = null;
        break;
    }
  }

  showPaymentDetailsButton() {
    if (
      (this.selectedLicenseAppPackagePrice != null &&
        this.selectedLicenseAppPackagePrice.status != LicenseMasterStatusEnum.PreSubscription &&
        this.selectedLicenseAppPackagePrice.status != LicenseMasterStatusEnum.None) ||
      (this.selectedleadGenPackage != null &&
        this.selectedleadGenPackage.status != LicenseMasterStatusEnum.PreSubscription &&
        this.selectedleadGenPackage.status != LicenseMasterStatusEnum.None &&
        this.selectedleadGenPackage.status != LicenseMasterStatusEnum.Offered)
    ) {
      return true;
    } else {
      return false;
    }
  }

  bookCall() {
    window.open("https://brickflow.com/brokers/brickflow-enterprise/book-a-demo");
  }

  hasLegacyLicense() {
    if (
      (this.isLegacyLicense &&
        this.selectedProduct &&
        this.selectedProduct.contractLength == ContractLengthEnum.None) ||
      (this.userOrganisation &&
        this.selectedLicenseAppPackagePrice &&
        this.userOrganisation.isLegacyLicense &&
        this.selectedLicenseAppPackagePrice.contractLength == ContractLengthEnum.None &&
        (!this.assignedLicense || this.selectedProduct.id == this.assignedLicense.id))
    ) {
      return true;
    } else {
      false;
    }
  }

  getLicenseStatusText() {
    this.allActiveAppPackagePrices = [];
    this.userClient.getLicenseStatusText(this.organisationAdminUsername).then((response) => {
      this.licenseStatusText = response;
    });
  }

  getWhiteLabelledUrl() {
    this.staticDataClient.getWhiteLabelledUrl().then((response) => {
      this.whiteLabelledUrl = response;
    });
  }

  gotoBrickflowPricingPrice() {
    window.open("https://brickflow.com/pricing");
  }

  returnPricingFrequency(BillingFrequency) {
    switch (BillingFrequency) {
      case BillingFrequencyEnum.Monthly:
        return PricingFrequencyEnum.Monthly;
        break;
      case BillingFrequencyEnum.Yearly:
        return PricingFrequencyEnum.Yearly;
        break;
      case BillingFrequencyEnum.OneOff:
        return PricingFrequencyEnum.OneOff;
        break;
      default:
        null;
        break;
    }
  }
}
